import AuthLoading from './AuthLoading';

export default AuthLoading;

